import axios from "axios";
import { GET_ALL_MEMBERSHIP_DETAILS } from "./types";

const keys = require("../config/keys");

export const getMembershipDetails = (data) => async (dispatch) => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/membership/getmembershipdetails",
    data: data,
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({
            type: GET_ALL_MEMBERSHIP_DETAILS,
            payload: res.data.data,
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};
